import { PTO_URL } from './const'

export const PTO_CHANGELOG_URL = `${PTO_URL}/changelog`
export const PTO_CHANGELOG_OBJECT_URL = `${PTO_CHANGELOG_URL}/object`
